// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51b20bab","455":"cdd72bde","977":"ee2477a9"}[chunkId] + ".chunk.js";
};